import { createContext } from "react";
const ContactUsContext = createContext({});
export default ContactUsContext;
